import OrderableModel from '@/models/OrderableModel';

export default class BusinessHourContract extends OrderableModel {
    get route () {
        return 'business-hour-contracts';
    }

    static get className () {
        return 'BusinessHourContract';
    }

    static get isInStore () {
        return true;
    }
}
